export default __webpack_public_path__ + "static/media/startImage.b5b40aa8.jpg";